<div fxLayoutAlign="start center">
  @if ($safeNavigationMigration(params()?.value) === null || $safeNavigationMigration(params()?.value) === undefined) {
    <span class="number-cell-value">-</span>
  } @else if (!params()?.isLink && !params()?.unit) {
    <span
      class="number-cell-value"
      [matTooltip]="$safeNavigationMigration(params()?.value) | numberFormat"
      matTooltipClass="regular-tooltip"
      matTooltipPosition="above"
      >{{ $safeNavigationMigration(params()?.value) | numberFormat }}</span
    >
  }
</div>
